import {Component, OnInit, OnDestroy} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TestRecordDataObject } from '../../../shared/services/submission-history-object';
import { SubmissionHistoryService } from '../../../shared/services/submission-history.service';
import { Subscription } from 'rxjs';
import { ModalService } from '../../../shared/services/modal.service';

@Component({
    selector: 'sample-details-sidebar',
    templateUrl: './sample-details-sidebar.component.html',
    styleUrls: [ './sample-details-sidebar.component.scss' ]
})
export class SampleDetailsSidebarComponent implements OnInit, OnDestroy {

    activeFileRecord: TestRecordDataObject;
    btnTrigger: any;
    private testSubmissionDataSubscription: Subscription;

    constructor(private submissionHistoryService: SubmissionHistoryService,
                private modalService: ModalService,
                private route: ActivatedRoute) {
        this.route.params.subscribe(res => this.getTestSubmissionData(res.id, res.sampleId));
    }

    ngOnInit() {
        this.testSubmissionDataSubscription = this.submissionHistoryService.currentTestSubmissionData.
            subscribe(message => this.activeFileRecord = message);
    }

    ngOnDestroy() {
        this.testSubmissionDataSubscription.unsubscribe();
        this.submissionHistoryService.clearTestSubmissionData();
    }

    public getTestSubmissionData(id: any, sampleId: any): void {
        this.submissionHistoryService.getTestSubmissionData(id, sampleId);
    }

    copyMessage(e: any, val: string){
      if (this.btnTrigger) {
        (this.btnTrigger as HTMLElement).classList.remove('down');
      }
      this.btnTrigger = e.target;
      if (this.btnTrigger instanceof HTMLElement) {
        (this.btnTrigger as HTMLElement).classList.add('down');
      }
      navigator.clipboard.writeText(val);
    }


    public displaySourceDialog(uuid: string, hmlId: string, uploaderFileName: string, submissionStatus: string, testType?: string): void {
        this.modalService.openSubmissionSourceDialog(uuid, hmlId, uploaderFileName, submissionStatus, testType);
    }
}
